import * as React from 'react';
import { OnHoverTooltip } from '../../common/OnHoverTooltip';
import IconSVG from '../../../styles/svg-icons';

export function AxedIcon() {
    return (
        <OnHoverTooltip wrapperClass="axed-icon-wrap" overlay="Axed">
            <IconSVG name="axed" width={16} height={16} />
        </OnHoverTooltip>
    );
}
